import React from 'react'
import NavigationBar from './components/navbar'




import './App.css';

function App() {
  return (
    <NavigationBar />
  );
}


export default App;
